import PhonePreviewIFrame from './PhonePreviewIFrame';
import './PhonePreviewIFrame.css';
import { bindActionCreators } from 'redux';
import withRouter from 'react-router-dom/withRouter';
import { connect } from 'react-redux';


function mapStateToProps(state, props){
  return {
    previewToken:props.match.params.previewToken
  }
}

function mapDispatchToProps(dispatch){
  return bindActionCreators({},dispatch);
}

export default withRouter(connect(mapStateToProps,mapDispatchToProps)(PhonePreviewIFrame));



// WEBPACK FOOTER //
// ./src/routes/PhonePreviewIFrame/index.js